module.exports = __webpack_public_path__ + "img/book-in.ee7e78e5.jpg";